import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { useTranslation } from '@root/shared/localization'
import {
  Dialog,
  LockerIcon,
  type DialogControlProps,
} from '@root/shared/ui-kit'
import { DialogHeader } from '@root/shared/ui-kit/dialog/header'
import { OtpInputInline } from '@root/shared/ui-kit/otp-input'

import type { OpenOtpModalController } from '@root/features/auth/authenticate'

type Props = {
  controller: OpenOtpModalController
} & DialogControlProps

/**
 * @deprecated
 */
export const EnterOtpDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  controller,
}) => {
  const [error, setError] = useState<boolean>(false)
  const [value, setValue] = useState<string | undefined>(undefined)
  const { t } = useTranslation()

  const [state] = useAtom(controller.stateAtom)
  const onOtp = useAction(controller.otpEnteredEvent)

  useEffect(() => {
    return controller.closeAction.onCall((_) => {
      onOpenChange?.(false)
    })
  }, [controller.closeAction, onOpenChange])

  useEffect(() => {
    if (value?.length === 6) {
      onOtp({ code: value })
    }
  }, [value, onOtp])
  useEffect(() => {
    if (AsyncStateN.isError(state)) {
      setError(true)
      setTimeout(() => setError(false), 1000)
    }
  }, [state])

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('otp.modal.title')}
    >
      <DialogHeader title={t('otp.modal.title')} />
      <Content>
        <Icon>
          <LockerIcon />
        </Icon>
        <Title>{t('otp.modal.title')}</Title>
        <Description>{t('otp.modal.subtitle')}</Description>
        <OtpInputInline
          value={value}
          onChange={setValue}
          disabled={state.loading}
          hasError={error}
        />
      </Content>
    </Root>
  )
}

const Root = styled(Dialog)``
const Content = styled.div`
  padding-inline: 24px;
  padding-block: 24px 32px;

  display: grid;
  place-items: center;
  place-content: center;
`

const Icon = styled.div`
  background: var(--backgroundA-4);

  display: grid;
  place-items: center;

  border-radius: 50%;
  width: 38px;
  height: 38px;
`

const Description = styled.div`
  color: var(--text-10);

  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-top: 6px;
  margin-bottom: 16px;
  max-width: 240px;

  > span {
    color: var(--text-12);
  }
`

const Title = styled.div`
  color: var(--text-12);

  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  margin-top: 12px;
`
